


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { exportInfor } from '@/api/index'

@Component({
  name: 'TitleIndex'
})
export default class extends Vue {
  @Prop() private flag!: number
  @Prop() private tateData!: string[]
  @Prop() private turnoverData!: any

  private nowIndex = 0
  private value = []
  private tabsParam = ['今日', '近7日', '近30日', '本周', '本月']

  get formatDateRange() {
    if (!this.tateData || !this.tateData.length) return ''
    
    const formatDate = (dateStr: string) => {
      const date = new Date(dateStr)
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${month}-${day}`
    }
    
    const start = formatDate(this.tateData[0])
    const end = formatDate(this.tateData[this.tateData.length - 1])
    return `${start} 至 ${end}`
  }

  @Watch('flag')
  getNowIndex(val: number) {
    this.nowIndex = val
  }

  toggleTabs(index: number) {
    this.nowIndex = index
    this.$emit('sendTitleInd', index)
  }

  async handleExport() {
    try {
      await this.$confirm('是否确认导出最近30天运营数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      
      const { data } = await exportInfor()
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', '运营数据统计报表.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      this.$message.success('导出成功')
    } catch (err) {
      if (err !== 'cancel') {
        this.$message.error('导出失败')
      }
    }
  }
}
